import React from "react";
import logo from "./logo.svg";
import Login from "./login";
import UploadCredential from "./Credentials/UploadCredential";
import ImpendingMaintenance from "./maintenance/impendingMaintenance";
import Maintenance from "./maintenance/maintenance";
import { Switch, Route, Link } from "react-router-dom";
import AppLayout from "./AppLayout";
import "./App.css";
import useAuth from "./auth/use-auth";
import { Result, Button } from "antd";

function App() {
  const { userHasValidToken } = useAuth();
  let isAuthenticated = userHasValidToken();

  return (
    <>
      <AppLayout>
        <Maintenance>
          <ImpendingMaintenance ShowImpendingMessageImmediately={true}>
            <Switch>
              <Route exact path="/">
                <Login />
              </Route>
              <Route path="/login">
                <Login />
              </Route>
              {isAuthenticated ? (
                <Route path="/uploadCredential">
                  <UploadCredential />
                </Route>
              ) : (
                <>
                  <Result
                    title="You must log in to continue"
                    subTitle="Your login has expired or you have not logged in yet"
                    extra={
                      <Button type="primary" key="console">
                        <Link to="/login">Login</Link>
                      </Button>
                    }
                  />
                </>
              )}
            </Switch>
          </ImpendingMaintenance>
        </Maintenance>
      </AppLayout>
    </>
  );
}

export default App;
